(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutInvestorProfileForm', [
			'$document',
			'$filter',
			'$timeout',
			'globalConfig',
			'US_STATES',
			'UserFactory',
			CheckoutInvestorProfileFormFunction
		]);

	function CheckoutInvestorProfileFormFunction(
		$document,
		$filter,
		$timeout,
		globalConfig,
		US_STATES,
		UserFactory) {
		
		var checkout = this;

		checkout.$onInit = function() {
			angular.extend(checkout, globalConfig);
			checkout.states = US_STATES;
			checkout.formValues.state = $filter('findSelectedOption')(checkout.formValues.state, 'abbreviation', checkout.states);
		};

		checkout.submit = function() {
			UserFactory.individual.details.save(buildPayload(), checkout.investorProfileForm)
				.then(function(data) {
					checkout.investmentEntityId = data.investmentEntityId;
					$timeout(function() {
						submitForm();
					});
				})
				.catch(function() {
					checkout.formSubmitted = false;
				});
		};

		function buildPayload() {
			var payload = angular.copy(checkout.formValues);

			payload.state = payload.state.abbreviation;

			payload.dateOfBirth = checkout.formattedDob;
			delete payload.year;
			delete payload.month;
			delete payload.day;

			return payload;
		}

		function submitForm() {
			$document[0].getElementById('successfulSubmissionForm').submit();
		}

	}
})(window.angular);